import { makeVar } from '@apollo/client';
import { useReactiveVar } from '@apollo/client/react';
const workflowStateVar = makeVar({});
const INITIAL_APPROVAL_STATE = {
    type: 'approval',
    result: undefined,
    latestWorkflowId: undefined,
};
const INITIAL_SIGNATORY_STATE = {
    type: 'signatory',
    result: undefined,
    latestWorkflowId: undefined,
};
const INITIAL_STATE = {
    approval: INITIAL_APPROVAL_STATE,
    signatory: INITIAL_SIGNATORY_STATE,
};
export const useWorkflowCheckState = (documentId) => {
    const state = useReactiveVar(workflowStateVar);
    const documentState = state[documentId] || INITIAL_STATE;
    const setDocumentState = (type, data) => {
        const currentState = workflowStateVar();
        const currentDocumentState = currentState[documentId] || INITIAL_STATE;
        const currentTypeState = currentDocumentState[type];
        workflowStateVar(Object.assign(Object.assign({}, currentState), { [documentId]: Object.assign(Object.assign({}, currentDocumentState), { [type]: Object.assign(Object.assign(Object.assign({}, currentTypeState), data), { type }) }) }));
    };
    const resetDocumentState = (type) => {
        setDocumentState(type, INITIAL_STATE[type]);
    };
    return { documentState, setDocumentState, resetDocumentState };
};
